"use client"

import dynamic from "next/dynamic"
import { Filter } from "lucide-react"

import { Button } from "@/components/atoms/Button/button"
import { Placeholder } from "@/components/atoms/Placeholder/placeholder"
import { useModalStore } from "@/hooks/useModal"

const FacetsContent = dynamic(() => import("./facets-content").then((m) => m.FacetsContent))
const GenericModal = dynamic(() => import("../Modal/modal").then((m) => m.GenericModal), {
  loading: Placeholder,
})

interface FacetsMobileProps {
  className?: string
  facetsDistribution: Record<string, any> | undefined
  disabledFacets?: string[]
  currentFilters: any
  onFilterChange(newFilters: Partial<Record<string, any>>): void
}

export function FacetsMobile({
  className,
  facetsDistribution,
  disabledFacets,
  onFilterChange,   
  currentFilters,
}: FacetsMobileProps) {
  const { modals, openModal, closeModal } = useModalStore()

  return (
    <div className={className}>
      <Button
        className="ml-5 px-2 py-2 [&>span]:flex [&>span]:items-center [&>span]:gap-4"
        onClick={() => openModal("fs-mobile")}
      >
        <Filter className="size-4 md:size-4" />
      </Button>
      {!!modals["fs-mobile"] && (
        <GenericModal
          className="h-full w-full overflow-auto"
          title="Filters"
          open={!!modals["fs-mobile"]}
          onOpenChange={() => closeModal("fs-mobile")}
        >
          <FacetsContent
            facetDistribution={facetsDistribution}
            disabledFacets={disabledFacets}
            currentFilters={currentFilters}
            onFilterChange={onFilterChange}
          />
        </GenericModal>
      )}
    </div>
  )
}
